import axios from '.';

export default {
  createStory,
  createStoryFromPost,
  getHomeStory,
  getStory,
  getProfileStory,
  updateStoryReadStatus,
  deleteStory,
  searchGeoapifyPlaces,
};

async function createStory(data, config) {
  let formData = new FormData();

  for (var key in data) {
    if (key === 'post_files') {
      for (let i = 0; i < data[key].length; i++) {
        formData.append('story_files[]', data[key][i]);
      }
    } else {
      formData.append(key, data[key]);
    }
  }
  const response = await axios.post('/api/stories', formData, config);
  return response.data;
}

async function getHomeStory(data) {
  let urlStr = '/api/stories?limit=15&page='+data?.page_no;
  if(data.startedAt){
    urlStr = urlStr + '&startedAt='+data.startedAt
  }
  const response = await axios.get(urlStr,data.user_id);
  return response.data;
}

async function getStory(data) {
  let urlStr = '/api/stories/single/'+data?.story_id;
  const response = await axios.get(urlStr,data.user_id);
  return response.data;
}

async function getProfileStory(data) {
  let urlStr = '/api/stories/performer/'+data.user_id+'?limit=15&page='+data.page_no;
  if(data.startedAt){
    urlStr = urlStr + '&startedAt='+data.startedAt
  }
  const response = await axios.get(urlStr);
  return response.data;
}

async function createStoryFromPost(data) {
  const response = await axios.post('/api/stories/from_post', data);
  return response.data;
}

async function updateStoryReadStatus(data) {
  const response = await axios.post('/api/stories/read_status', data);
  return response.data;
}

async function deleteStory(data) {
  const response = await axios.delete('/api/stories/'+data.story_id);
  return response.data;
}

function normalizeGeoapifyPlacesResponse(data) {
  const features = data?.features ?? data?.data?.features ?? data?.data ?? [];

  if (!Array.isArray(features) || features.length === 0) {
    return [];
  }

  if (typeof features[0] === 'string') {
    return [...new Set(features.filter(Boolean))];
  }

  const locations = features
    .map((feature) => feature?.properties?.formatted ?? feature?.formatted ?? feature?.name)
    .filter(Boolean);

  return [...new Set(locations)];
}

async function searchGeoapifyPlaces(term, config = {}) {
  const response = await axios.get('/api/geoapify/places/search', {
    params: { term },
    signal: config.signal,
  });

  return normalizeGeoapifyPlacesResponse(response.data);
}
